import { styled, Stack, Box } from '@mui/material'

export const Container = styled(Stack)`
  height: 100%;
  min-height: 400px;
`

export const MainSection = styled(Box)`
  flex: 1;
  width: 100%;
`

export const UpdateSection = styled(Stack)`
  align-self: flex-end;
  padding: 16px;
  justify-content: center;
  align-items: flex-end;
`

export const SettingsRow = styled(Stack)`
  flex-direction: row;
  gap: 8px;
`

export const SettingsItemWrapper = styled(Stack)`
  width: 240px;
  height: 50px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.palette.background.default};
`
